import React, { Component, useState, useRef, useEffect } from "react";
import {
  Form,
  FormInstance,
  Input,
  message,
  Radio,
  Select,
  TreeSelect,
  Upload,
  Table,
  Button,
  Drawer,
  Spin,
} from "antd";
import {
  DownOutlined,
  UpOutlined,
  ClearOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  InboxOutlined,
  PlusOutlined,
  SaveOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { CLIENT_URL } from "../../requests/config";
import react_parse from "html-react-parser";
import styles from "./apply.module.scss";
import clsx from "clsx";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const PSPDFKit = await import("pspdfkit");

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function group_columns(array, is_col) {
  let columns = [];
  let columned_items = [];

  array.map((v, ind) => {
    if (is_col(v, true) || is_col(v, false)) {
      if (is_col(v, true)) {
        columns.push([ind]);
      } else {
        columns[columns.length - 1].push(ind);
      }
    }
  });
  array.map((v, ind) => {
    if (!is_col(v, true) && !is_col(v, false)) {
      let found = false;
      for (const [start, end] of columns) {
        if (ind > start && ind < end) {
          if (start === ind - 1) {
            columned_items.push([v]);
          } else {
            columned_items[columned_items.length - 1].push(v);
          }

          found = true;
        }
      }
      !found && columned_items.push(v);
    }
  });
  return columned_items;
}

function DurableFileDragger({ onChange, field_id, initialFileList, ...props }) {
  const [fileList, setFileList] = useState(initialFileList);
  return (
    <Upload.Dragger
      name="file"
      fileList={fileList}
      multiple={true}
      onChange={({ fileList: newFileList, ...pps }) => {
        setFileList(newFileList);
        onChange(newFileList);
      }}
      action={`${CLIENT_URL}/api/upload`}
      {...props}
      showUploadList={{
        showDownloadIcon: true,
        downloadIcon: (file) => (
          <DownloadOutlined
            onClick={() => window.open(file.url || file.response?.url, "_blank")}
          />
        ),
      }}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        Click or drag file to this area to upload
      </p>
    </Upload.Dragger>
  );
}

function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}

/**
 *
 * @param onChange
 * @param initialVideoUrl
 * @param disabled
 * @param placeholder
 * @param {FormInstance} form
 * @param field_id
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function VideoWithPreview({
  field,
  visible,
  initialVideoUrl,
  disabled,
  form,
  field_id,
}) {
  const [is_preview, setIsPreview] = useState(
    (initialVideoUrl || "").length > 0
  );
  const [videoSource, setVideoSource] = useState(initialVideoUrl);
  const fieldRef = useRef();

  useEffect(() => {
    if (form) {
      form.setFields([
        {
          name: field.name,
          value: videoSource,
          errors: form.getFieldError(field.name),
        },
      ]);
    }
  }, [videoSource]);
  return (
    <Form.Item
      label={<b>{field.label}</b>}
      name={field.name}
      id={field.uid}
      required={visible && (field.required || false)}
      tooltip={
        (field.tooltip || "").length > 0 &&
        react_parse(`<span>${field.tooltip}</span>`, { trim: true })
      }
      hidden={!visible}
      extra={field.description}
      validateTrigger={["onBlur", "onFocus", "onHover"]}
      rules={
        visible && [
          {
            validator(rule, value) {
              if (is_preview) {
                return Promise.resolve();
              } else {
                return Promise.reject(
                  new Error(
                    "Click the save icon on the right side of the input to save and preview your video."
                  )
                );
              }
            },
          },
          ...field.rules.map((rule) => {
            if (rule.pattern != null) {
              return { ...rule, pattern: new RegExp(rule.pattern) };
            } else {
              return rule;
            }
          }),
        ]
      }
    >
      <span>
        {is_preview ? (
          <iframe
            allowFullScreen={true}
            style={{
              width: "100%",
              height: 300,
              background: "#000",
              borderRadius: 15,
            }}
            frameBorder={0}
            src={videoSource}
          />
        ) : (
          <Upload.Dragger
            accept={"video/mp4, video/3gp, video/mov"}
            action={"/api/upload"}
            multiple={false}
            onChange={({ fileList: newFileList, ...ev }) => {
              if (newFileList?.[0]?.response?.url) {
                fieldRef?.current?.handleChange({
                  target: {
                    value: newFileList?.[0]?.response?.url,
                  },
                });
                setIsPreview(true);
              }
            }}
            disabled={disabled}
            showUploadList={{
              showDownloadIcon: true,
              downloadIcon: (file) => (
                <DownloadOutlined
                  onClick={() =>
                    window.open(file.url || file.response?.url, "_blank")
                  }
                />
              ),
            }}
          >
            {
              <>
                <p className="ant-upload-drag-icon">
                  <VideoCameraOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag a video file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Upload a *.mp4/*.3gp/*.mov Files.
                </p>
              </>
            }
          </Upload.Dragger>
        )}
      </span>

      <Input
        placeholder={field.placeholder || field.label || field.title}
        // ref={fieldRef}
        value={videoSource}
        onChange={(val) => {
          setVideoSource(val.target.value);
        }}
        style={{ marginTop: 10 }}
        disabled={disabled || is_preview}
        addonAfter={
          is_preview ? (
            <CloseCircleOutlined
              style={{ color: "gray", fontSize: 16, height: "auto" }}
              onClick={() => {
                setIsPreview(false);
              }}
            />
          ) : (
            <SaveOutlined
              style={{ color: "gray", fontSize: 16, height: "auto" }}
              onClick={() => {
                if (
                  !/((https:\/\/|http:\/\/)?(www.)?youtube.com\/watch\?v=*.+)|(https:\/\/www.youtube.com\/embed\/*.+)|((http|https):\/\/*.+\.(mp4|mov|3gp))/g.test(
                    videoSource
                  )
                ) {
                  message.warn(
                    "Either a youtube embed link or a url to a video (MP4, 3GP OR MOV) is required!"
                  );
                } else {
                  if (
                    /((https|http)?:\/\/(www.)?youtube.com\/watch\?v=*.+)/g.test(
                      videoSource
                    )
                  ) {
                    setVideoSource(
                      `https://www.youtube.com/embed/${youtube_parser(
                        videoSource
                      )}`
                    );
                    setIsPreview(true);
                  } else {
                    setIsPreview(true);
                  }
                }
              }}
            />
          )
        }
      />
    </Form.Item>
  );
}

const { Option } = Select;
export default class AbstractForm extends Component {
  constructor(props) {
    super(props);
    const { fields } = this.props;
    this.fields = fields;
    let visibility_reqs = {};
    let opened_pdf = [];

    const merge = (...vals) => `${vals.join("-")}`;

    for (const field of fields) {
      visibility_reqs[field.uid] = field.conditions.map((req) =>
        merge(req.field, req.operator, req.value)
      );
    }
    this.state = {
      visible_fields: fields
        .filter((field) => field.conditions.length === 0)
        .map((field) => field.uid),
      category: "",
      open: false,
      editdrawer: false,
      selectedRow: -1,
      selectedValue: {},
      table_value: {},
      field: {},
      column: [],
      field_id: "",
      opened_pdf: {},
      loading: {},
      selected_field_id: [],
    };
    this.fieldRefs = {};
    const conditions = groupBy(
      this.fields
        .map((v) =>
          v.conditions.map((cond) => ({
            ...cond,
            use: v.uid,
          }))
        )
        .flat(),
      "field"
    );
    this.conditions = conditions;
    let timer_waiter = 0;
    const update = (cond, currValue) => {
      clearTimeout(timer_waiter);
      timer_waiter = setTimeout(
        async () =>
          conditions[cond].map((dependency) => {
            const is_condition = this.dependency_validator(
              currValue,
              dependency.operator,
              dependency.value
            );
            const local_fields = this.state.visible_fields;
            const condid = merge(cond, dependency.operator, dependency.value);
            if (is_condition) {
              if (visibility_reqs[dependency.use].indexOf(condid) !== -1) {
                if (local_fields.indexOf(dependency.use) === -1) {
                  visibility_reqs[dependency.use].splice(
                    visibility_reqs[dependency.use].indexOf(condid),
                    1
                  );
                  if (visibility_reqs[dependency.use].length === 0) {
                    local_fields.push(dependency.use);
                    this.setState({ visible_fields: [...local_fields] });
                  }
                }
              }
            } else {
              if (visibility_reqs[dependency.use].indexOf(condid) === -1) {
                if (local_fields.indexOf(dependency.use) !== -1) {
                  visibility_reqs[dependency.use].push(condid);
                  local_fields.splice(local_fields.indexOf(dependency.use), 1);
                  this.setState({ visible_fields: [...local_fields] });
                }
              }
            }
          }),
        300
      );
    };
    this.update = update;
    Object.keys(conditions).map((cond) => {
      this.fieldRefs[cond] = (id) => {
        update(cond, this.props.form.current.getFieldValue(id));
      };
    });

    const showDrawer = () => {
      this.setState({
        open: true,
      });
    };
    this.showDrawer = showDrawer;

    const updateDrawerForm = (field, index) => {
      const { table_value } = this.state;
      const { selectedRow } = this.state;
      if (selectedRow != -1) {
        const obj_val = field.columns.map((col_val) => {
          return {
            dataIndex: col_val.fieldname,
            value:
              table_value[this.state.field_id][selectedRow][col_val.fieldname],
          };
        });
        const intial_value_for_Drawer_form = obj_val
          .map((item) => {
            return { [item.dataIndex]: item.value };
          })
          .reduce((prev, curr) => {
            return { ...prev, ...curr };
          }, {});

        this.setState({
          open: true,
          selectedValue: intial_value_for_Drawer_form,
        });
      }
    };
    this.updateDrawerForm = updateDrawerForm;

    const onClose = () => {
      this.setState({
        open: false,
        selectedValue: {},
      });
    };
    this.onClose = onClose;
  }

  handleLoad = (field_id) => {
    const { loading } = this.state;
    loading[field_id] = false;
    this.setState({ loading: loading });
  };

  /**
   *
   * @param {{type: "input"| "textarea" | "attachment"| "video" | "currency"  | "title" | "date" | "select" | "radio"| "company" | "tag" |"group", maxTag   , inputType , options: {}, treeData, href , title }} field
   *
   */
  typed_render(field, onChange, placeholder, field_id) {
    switch (field?.type) {
      case "textarea": {
        return (
          <Input.TextArea
            disabled={this.props.disabled || false}
            onChange={onChange}
            placeholder={placeholder}
            prefix={field.prefix}
            type={field?.inputType}
            // defaultValue={this.props.prev_data[field_id]}
          />
        );
      }
      case "Data": {
        return (
          <Input
            disabled={this.props.disabled || false}
            onChange={onChange}
            prefix={field.prefix}
            placeholder={placeholder}
            type={field.inputType}
            // defaultValue={this.props.prev_data[field_id]}
          />
        );
      }

      case "input": {
        return (
          <Input
            disabled={this.props.disabled || false}
            onChange={onChange}
            prefix={field.prefix}
            placeholder={placeholder}
            type={field.inputType}
            // defaultValue={this.props.prev_data[field_id]}
          />
        );
      }

      case "Date":
      case "date": {
        return (
          <Input
            type={"date"}
            disabled={this.props.disabled || false}
            // defaultValue={this.props.prev_data[field_id]}
          />
        );
      }

      case "Text Editor": {
        return <ReactQuill theme="snow" />;
      }

      case "Select": {
        return (
          <Select
            maxTagCount={1}
            mode={field.is_multiple && "multiple"}
            disabled={this.props.disabled || false}
            placeholder={placeholder}
            onChange={onChange}
            // defaultValue={this.props.prev_data[field_id]}
          >
            {field.options.split("\n").map((key) => (
              <Option value={key}>{key}</Option>
            ))}
          </Select>
        );
      }

      case "select": {
        return (
          <Select
            maxTagCount={1}
            mode={field.is_multiple && "multiple"}
            disabled={this.props.disabled || false}
            placeholder={placeholder}
            onChange={onChange}
            // defaultValue={this.props.prev_data[field_id]}
          >
            {field.options.map((key, index) => (
              <Option value={key}>{key}</Option>
            ))}
          </Select>
        );
      }

      case "radio": {
        return (
          <Radio.Group
            disabled={this.props.disabled || false}
            placeholder={placeholder}
            onChange={onChange}
            // defaultValue={this.props.prev_data[field_id]}
          >
            {field.options.map((key) => (
              <Radio.Button value={key}>{key}</Radio.Button>
            ))}
          </Radio.Group>
        );
      }

      case "tag": {
        return (
          <TreeSelect
            disabled={this.props.disabled || false}
            placeholder={placeholder}
            onChange={onChange}
            maxTagCount={field.maxTag}
            treeCheckable
            treeData={field.treeData}
          />
        );
      }

      case "attachment": {
        return (
          <div>
            <DurableFileDragger
              initialFileList={
                this.props.prev_data[field_id]
                  ? this.props.prev_data[field_id]
                  : []
              }
              disabled={this.props.disabled || false}
              onChange={(newFileList) => {
                onChange();
                this.props.form.current.setFieldsValue({
                  [field_id]: newFileList,
                });
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </DurableFileDragger>
            {this.props.disabled && (
              <div className="">
                <p
                  className=" border-[1px] bg-[#F5F5F5] mt-5 mb-2 p-2 flex justify-between items-center cursor-pointer"
                  onClick={() => {
                    const { selected_field_id, loading } = this.state;
                    if (selected_field_id.includes(field_id)) {
                      const newArray = selected_field_id.filter(
                        (item) => item !== field_id
                      );
                      this.setState({ selected_field_id: newArray });
                    }
                    if (loading[field_id] === undefined) {
                      loading[field_id] = true;
                      this.setState({ loading: loading });
                    }
                    if (!selected_field_id.includes(field_id)) {
                      selected_field_id.push(field_id);
                      this.setState({ selected_field_id: selected_field_id });
                    }
                    let temp_obj = this.state.opened_pdf;
                    if (this.state.opened_pdf[field_id] != undefined) {
                      temp_obj[field_id] = !temp_obj[field_id];
                      this.setState({ opened_pdf: temp_obj });
                    } else {
                      temp_obj[field_id] = true;
                      this.setState({ opened_pdf: temp_obj });
                    }
                  }}
                >
                  View File
                  {this.state.opened_pdf[field_id] ? (
                    <UpOutlined />
                  ) : (
                    <DownOutlined />
                  )}
                </p>
                {this.state.loading[field_id] &&
                  this.state.selected_field_id?.includes(field_id) && (
                    <div className=" w-full flex items-center justify-center mt-[35%]">
                      <Spin size="large" />
                    </div>
                  )}

                {this.props.secondary_form &&
                this.props.prev_data[this.props.current_form] ? (
                  this.props.prev_data[this.props.current_form][field_id][0]
                    ?.type === "application/msword" ? (
                    <div
                      className={`${
                        this.state.opened_pdf[field_id] ? "" : "hidden"
                      }`}
                    >
                      <>word doc</>
                    </div>
                  ) : (
                    <embed
                      className={`${
                        this.state.opened_pdf[field_id] ? "" : "hidden"
                      }`}
                      src={`${
                        window.location.protocol === "https:"
                          ? this.props.prev_data[this.props.current_form][
                              field_id
                            ][0]?.response?.url
                          : this.props.prev_data[this.props.current_form][
                              field_id
                            ][0]?.response?.url?.replace("https", "http")
                      }`}
                      // src="https://www.africau.edu/images/default/sample.pdf"
                      width="100%"
                      height="600px"
                      onLoad={() => this.handleLoad(field_id)}
                    />
                  )
                ) : Array.isArray(this.props.prev_data.data) &&
                  this.props.prev_data.includes(field_id) &&
                  this.props.prev_data[field_id][0]?.type ===
                    "application/msword" ? (
                  <div
                    className={`${
                      this.state.opened_pdf[field_id] ? "" : "hidden"
                    }`}
                  >
                    <>Word doc not supported</>
                  </div>
                ) : this.props.prev_data[field_id] &&
                  this.props.prev_data[field_id][0] ? (
                  <embed
                    className={`${
                      this.state.opened_pdf[field_id] ? "" : "hidden"
                    }`}
                    src={`${
                      window.location.protocol === "https:"
                        ? this.props.prev_data[field_id][0]?.response?.url
                        : this.props.prev_data[
                            field_id
                          ][0]?.response?.url?.replace("https", "http")
                    }`}
                    // src="https://www.africau.edu/images/default/sample.pdf"
                    width="100%"
                    height="600px"
                    onLoad={() => this.handleLoad(field_id)}
                  />
                ) : (
                  <p>No data found for the specified field ID</p>
                )}
              </div>
            )}
          </div>
        );
      }
      case "title": {
        return (
          <>
            <h1 className={styles.form_group_title} id={field.uid}>
              <b>
                {field.href ? (
                  <a href={field.href}>{field.label}</a>
                ) : (
                  field.label
                )}
              </b>
            </h1>
          </>
        );
        /*                    <div style={{width:"100%", height:1, backgroundColor:"#DFE7EF", marginBottom:20}}/>
         */
      }
      case "Table": {
        if (this.props.prev_data[field_id]) {
          if (this.state.table_value[field_id]) {
          } else {
            this.state.table_value[field_id] = this.props.prev_data[field_id];
          }
        }

        return (
          <>
            <Button
              style={{
                marginBottom: 10,
              }}
              type="primary"
              onClick={() => {
                this.setState(
                  {
                    editdrawer: false,
                  },
                  () => {
                    this.setState(
                      {
                        field: field,
                        column: field.columns,
                        field_id: field_id,
                      },
                      () => {
                        this.showDrawer();
                      }
                    );
                  }
                );
              }}
              disabled={this.props.disabled}
            >
              Add a list
            </Button>

            <Drawer
              title={this.state.field.name}
              width={720}
              onClose={this.onClose}
              visible={this.state.open}
              bodyStyle={{ paddingBottom: 80 }}
            >
              <Form
                layout="vertical"
                onFinish={(values) => {
                  if (this.state.editdrawer) {
                    this.handleedit(values);
                  } else {
                    this.handleUpdate(values);
                  }
                  this.setState({
                    open: false,
                    selectedValue: {},
                  });
                }}
                initialValues={this.state.selectedValue}
              >
                {this.state.column.map((col_val) => {
                  return this.drawer_field_item(col_val);
                })}

                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    borderTop: "1px solid #e8e8e8",
                    padding: "10px 16px",
                    textAlign: "right",
                    left: 0,
                    background: "#fff",
                    borderRadius: "0 0 4px 4px",
                  }}
                >
                  <Button
                    style={{
                      marginRight: 8,
                    }}
                    onClick={this.onClose}
                  >
                    Cancel
                  </Button>
                  <Button htmlType="submit" type="primary">
                    {this.state.editdrawer ? "Update" : "Submit"}
                  </Button>
                </div>
              </Form>
            </Drawer>
            <Table
              columns={[
                ...field.columns.map((col_val) => ({
                  title: col_val.Column,
                  dataIndex: col_val.fieldname,
                  key: col_val.fieldname,
                  width: 200,
                  render: (val, row) => {
                    return <div dangerouslySetInnerHTML={{ __html: val }} />;
                  },
                })),
                {
                  title: "",
                  dataIndex: "actions",
                  key: "actions",
                  width: 150,
                  render: (val, row, index) => {
                    return (
                      <div>
                        <Button
                          style={{
                            marginRight: 20,
                            color: "#348ef7",
                            borderColor: "#348ef7",
                          }}
                          disabled={this.props.disabled}
                          onClick={() => {
                            this.setState(
                              {
                                selectedRow: index,
                                editdrawer: true,
                                field: field,
                                column: field.columns,
                                field_id: field_id,
                              },
                              () => {
                                this.updateDrawerForm(field, index, field_id);
                              }
                            );
                          }}
                        >
                          <EditOutlined />
                        </Button>
                        <Button
                          style={{
                            marginRight: 20,
                            color: "#d62929",
                            borderColor: "#d62929",
                          }}
                          disabled={this.props.disabled}
                          onClick={() => {
                            const { table_value } = this.state;
                            const newData = [...table_value[field_id]];
                            newData.splice(index, 1);
                            this.state.table_value[field_id] = newData;
                            this.props.onValueChange(newData, field_id);
                          }}
                        >
                          <DeleteOutlined />
                        </Button>
                      </div>
                    );
                  },
                },
              ]}
              dataSource={this.state.table_value[field_id]}
              bordered
              size="middle"
              scroll={{
                y: 240,
              }}
            />
          </>
        );
      }
      case "company": {
        return (
          <Select
            disabled={this.props.disabled || false}
            placeholder={placeholder}
            onChange={onChange}
          >
            <Option value={"key"}>{"key"}</Option>
          </Select>
        );
      }
    }
  }

  dependency_validator(currValue, operator, required) {
    let result = false;
    switch (operator) {
      case "=": {
        result = currValue.toString() === required.toString();
        break;
      }
      case "!=": {
        result = currValue.toString() !== required.toString();
        break;
      }
      case ">": {
        result = Number(currValue) > Number(required);
        break;
      }
      case "<": {
        result = Number(currValue) < Number(required);
        break;
      }
      case ">=": {
        result = Number(currValue) >= Number(required);
        break;
      }
      case "=<": {
        result = Number(currValue) <= Number(required);
        break;
      }
      case "!": {
        result = (currValue || "").toString().trim().length > 0;
        break;
      }
    }
    return result;
  }

  componentDidMount() {
    setTimeout(() => {
      const field_values = this.props.form.current?.getFieldsValue?.(
        Object.keys(this.conditions)
      );
      for (const key of Object.keys(field_values)) {
        this.update(key, field_values[key] || "");
      }
    }, 1000);
  }

  handleUpdate = (values) => {
    const { table_value } = this.state;
    const newData = [...(table_value[this.state.field_id] || [])];
    newData.push(values);
    this.state.table_value[this.state.field_id] = newData;
    this.props.onValueChange(newData, this.state.field_id);
  };

  handleedit = (values, index) => {
    const { table_value } = this.state;
    const newData = [...(table_value[this.state.field_id] || [])];
    newData.splice(this.state.selectedRow, 1, values);
    this.state.table_value[this.state.field_id] = newData;
    this.props.onValueChange(newData, this.state.field_id);
    this.state.selectedRow = -1;
  };

  repeat_group_container(field) {
    const visible = this.state.visible_fields.indexOf(field.uid) !== -1;

    return (
      <>
        {visible && (
          <Form.List name={field.uid}>
            {(fields, { add, remove }) => (
              <div className={styles.repeat_container}>
                <h1
                  className={clsx(
                    styles.form_group_title,
                    styles.repeat_group_title
                  )}
                >
                  <b>{field.label}</b>
                </h1>
                {fields.map(({ name, key, fieldKey, ...restField }) => {
                  return (
                    <div key={key} className={styles.close_container}>
                      <div className={styles.repeat_group}>
                        {field.data.fields.map((_field) => (
                          <div className={styles.form_item}>
                            {this.field_item(
                              {
                                ..._field,
                                uid: _field.uid + `_${key}`,
                                name: [name, _field.name],
                              },
                              true,
                              true,
                              {
                                restField,
                                fieldKey: [fieldKey, _field.name],
                              }
                            )}
                          </div>
                        ))}
                      </div>
                      {!(this.props.disabled || false) && (
                        <DeleteOutlined
                          className={styles.repeat_delete}
                          onClick={() => {
                            if (
                              (field.data.minimum_repeats || 0) < fields.length
                            ) {
                              remove(name);
                            }
                          }}
                        />
                      )}
                    </div>
                  );
                })}
                {field.description && (
                  <span className={styles.description_text}>
                    {field.description}
                  </span>
                )}
                {!(this.props.disabled || false) && (
                  <div
                    className={styles.new_button}
                    onClick={() => {
                      if (
                        field.data.max_repeat === -1 ||
                        fields.length < field.data.max_repeat
                      ) {
                        add();
                      }
                    }}
                  >
                    <PlusOutlined /> Add
                  </div>
                )}
              </div>
            )}
          </Form.List>
        )}
      </>
    );
  }

  /***
   *
   * @param {Object} field
   * @param is_visible
   * @param is_small
   * @param additional_info
   * @param {string} field.placeholder
   * @return {JSX.Element}
   */
  field_item(field, is_visible = false, is_small = false, additional_info) {
    const visible =
      is_visible || this.state.visible_fields.indexOf(field.uid) !== -1;

    return (
      <Form.Item
        {...(additional_info?.restField || {})}
        {...((!visible && { value: null }) || {})}
        label={<b>{field.label}</b>}
        name={field.name}
        id={field.uid}
        required={visible && (field.required || false)}
        tooltip={
          (field.tooltip || "").length > 0 &&
          react_parse(`<span>${field.tooltip}</span>`, { trim: true })
        }
        hidden={!visible}
        fieldKey={additional_info?.fieldKey}
        size={is_small && "small"}
        // extra={field.description}
        rules={
          visible &&
          field.rules.map((rule) => {
            if (rule.pattern != null) {
              return { ...rule, pattern: new RegExp(rule.pattern) };
            } else {
              return rule;
            }
          })
        }
      >
        {this.typed_render(
          field.data,
          () => {
            this.fieldRefs[additional_info?.internal_uid || field.uid]?.(
              additional_info?.internal_name || field.name
            );
          },
          field.placeholder || field.label || field.title,
          field.name
        )}
      </Form.Item>
    );
  }

  drawer_field_item(
    field,
    is_visible = false,
    is_small = false,
    additional_info
  ) {
    const visible =
      is_visible || this.state.visible_fields.indexOf(field.uid) !== -1;

    return (
      <Form.Item
        label={<b>{field.Column}</b>}
        name={field.fieldname}
        id={field.fieldname}
        {...(field.type === "Text Editor" ? { initialValue: "" } : {})}
        hidden={false}
        // size={is_small && "small"}
      >
        {this.typed_render(
          field,
          () => {
            this.fieldRefs[additional_info?.internal_uid || field.fieldname]?.(
              additional_info?.internal_name || field.Column
            );
          },
          field.placeholder || field.Column,
          field.fieldname
        )}
      </Form.Item>
    );
  }

  render() {
    const { visible } = this.props;
    return (
      <div style={{ display: visible ? "unset" : "none" }}>
        <>
          {group_columns(this.fields, (field, start) => {
            return field?.data?.type === (start ? "colstart" : "colend");
          }).map((field_unk) =>
            Array.isArray(field_unk) ? (
              <div className={styles.column_break}>
                {field_unk.map((field) => this.field_item(field))}{" "}
              </div>
            ) : field_unk?.type !== "title" ? (
              field_unk?.data?.type === "group" ? (
                this.repeat_group_container(field_unk)
              ) : field_unk?.data?.type === "video" ? (
                <VideoWithPreview
                  visible={
                    this.state.visible_fields.indexOf(field_unk.name) !== -1
                  }
                  field={field_unk}
                  form={this.props?.form?.current}
                  initialVideoUrl={this.props.prev_data[field_unk.name] || ""}
                  disabled={this.props.disabled || false}
                />
              ) : (
                this.field_item(field_unk)
              )
            ) : (
              this.typed_render(field_unk)
            )
          )}
        </>
      </div>
    );
  }
}
